<template>
    <div class="success-container">
        <head-bar title="支付成功" :border="true" :fixed="true"></head-bar>
        <div class="icon-box"></div>
        <div class="icon-text">
            <span>支付成功</span>
        </div>
        <div class="urgent-content" v-if="hasUrgentStatus">
            <div class="urgent-text">
                <p
                    v-if="
                        urgentInfo.orderPriorityState ==
                            orderUrgentStatusMap.urgentFailed
                    "
                >
                    <i class="waring-icon"></i>
                    加急失败
                </p>
                <p
                    v-if="
                        urgentInfo.orderPriorityState ==
                            orderUrgentStatusMap.urgentWait
                    "
                >
                    订单已申请加急发货，请耐心等待加急结果
                </p>
                <p
                    class="arrival-time"
                    v-if="
                        urgentInfo.orderPriorityState ==
                            orderUrgentStatusMap.urgentWait
                    "
                >
                    {{ urgentInfo.urgentEstimatedDeliveryTime }}
                </p>
                <p
                    class="arrival-time"
                    v-if="
                        urgentInfo.orderPriorityState ==
                            orderUrgentStatusMap.urgentFailed
                    "
                >
                    {{ urgentInfo.estimatedDeliveryTime }}
                </p>
            </div>
            <div class="urgent-icon"></div>
            <div class="urgent-service">
                <span>如果加急不成功专属客服会联系您</span>
            </div>
        </div>
        <div class="btn-group">
            <div class="btn-item back-index" @click="$router.push('/')">
                <span>回到首页</span>
            </div>
            <div
                class="btn-item back-info"
                @click="$router.push('/user/order/list')"
            >
                <span>查看订单详情</span>
            </div>
        </div>
    </div>
</template>
<script>
import HeadBar from "@/components/HeadBar.vue";
import { isEmpty } from "@/utils/validation";
import { orderUrgentStatusMap } from "../../definition/status/order";
export default {
    name: "PaySuccess",
    components: {
        HeadBar,
    },
    data() {
        return {
            hasUrgentStatus: false,
            urgentInfo: {
                orderPriorityState: orderUrgentStatusMap.urgentFailed,
                orderPriorityStateDesc: "",
                urgentEstimatedDeliveryTime: "",
                estimatedDeliveryTime: "",
            },
            orderUrgentStatusMap: orderUrgentStatusMap,
        };
    },
    beforeMount() {
        let { orderNo } = this.$route.query;
        // if (isEmpty(orderNo)) {
        //     this.$router.push({
        //         path: "/",
        //     });
        //     return false;
        // }
        this.queryOrderUrgentStatus(orderNo);
    },
    methods: {
        queryOrderUrgentStatus(orderNo) {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let queryURL = this.$api.orderApi.order_queryUrgentStatus;
            this.$axios
                .post(queryURL, {
                    context: {
                        orderNo: orderNo,
                    },
                })
                .then((res) => {
                    let { data: urgentInfo = {} } = res;
                    let hasUrgentStatus = !isEmpty(urgentInfo);
                    this.hasUrgentStatus = hasUrgentStatus;
                    if (hasUrgentStatus) {
                        this.urgentInfo = Object.assign({ ...urgentInfo });
                    }
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
    },
};
</script>
<style lang="less" scoped>
.success-container {
    padding-top: 90px;
    width: 750px;
    .icon-box {
        margin: 75px auto 45px;
        width: 140px;
        height: 140px;
        background-image: url("../../public/images/pay/pay-success-icon.png");
        background-size: 140px;
    }
    .icon-text {
        text-align: center;
    }
    .btn-group {
        margin-top: 70px;
        height: 60px;
        font-size: 0;
        text-align: center;
        .btn-item {
            *display: inline;
            display: inline-block;
            zoom: 1;
            height: 54px;
            width: 176px;
            border: 1px solid #dedede;
            border-radius: 30px;
            font-size: 24px;
            line-height: 54px;
            color: #333;
            &.back-index {
                margin-right: 58px;
                width: 176px;
            }
            &.back-info {
                width: 224px;
            }
        }
    }
    .urgent-content {
        margin: 40px auto 0;
        padding: 50px 0 20px;
        width: 668px;
        border: 2px dashed #dedede;
        .urgent-text {
            font-size: 28px;
            text-align: center;
            color: #333;
            .waring-icon {
                *display: inline;
                display: inline-block;
                zoom: 1;
                margin-right: 5px;
                width: 32px;
                height: 32px;
                background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAv5JREFUWEfVmFtIVEEYx3+jkpoIQQa9GNiNBF8qSirxIUIjodTarTCiIspEo4IMgp4CiyRQ2sh6sui6J7pBQuFDhAUhGUkXHyrDLghaiWFqkBPnuGt7jrt7xl2DcZ6Wc/7nP7/5Zr+Zb0ageROa8xEzoPSQhaAQyEOSDcwB0gMD/gl0IXgLtCB5IAw6YwnGhAClh0QkHgSVwEpQHqAEniLxITCEwR9VWGVA6WUNI5xBsEjVPKxO0kECVcJPs4qPK6DcQQq/qEOyZwIRc+tbIrjAdA6IRoaiiaMCSg+zgPvAMrceY3zfChQJg55I30cEDMA9hjin1J28A8iPBBkW0JrWAUy4/xU5J3YraeSHm+7wgF4akOx1H/wkKgTnhZ9yp+M4QCtbJQ8nMSFUR2EmToEzu22AgXXuVdxLiSqSU2cuQYKc0HXSDriJLQiuRfVPSIKc1dBuBlmhZedDRwvIEQUxINkqbnI9KHZGsAVYFdVplw8KK+B2Ddw4BtLcJCK09dVQdgKa6uHiITVAeCIM8sYBylLmksi7qP+9ggrYffZfR89ugW87DA/YOxcJsLMe1po7YqA1HoSmOhVIc8Tzgnv3WASll3Ik5yI6pGeA7wOkBuuBgLLzBZzaAN8+jT6Ylgr7r8LyYrvV70Gomg8/vrpDCvYJPw2mMBTwMpKyqF8vyIXDd2DGbLusrxtqi6H7PRy5BwtX2N8P9EFtCbx55A43SnVF+NlmB/TwHFji6jAzE6rvQtZiR4SGoL8HMjLtz3u7oGYdfH7tah0iaBMGS52A5n6YoeSSnAaVlyC3NLr840s4WQTfvyjZhoh6hWHVASFT7LGqimRlJyFg83EoOQrmb2drb4bTG2GwX9kyRDgsDFKmHKD2U6x5knjRfJnRfqHWfaszU1p60LdYsACnQLllHsz1LVitKOpc8ge3GqnzocmKou7HzkBGm9WEngf3sanW+epjDFLny6PQQk7b6zcbpM4XmM6y2DqmJlGg1RVwLLV7vN+43rDG20G83/8FwkZgONlN7QYAAAAASUVORK5CYII=");
                background-repeat: no-repeat;
                background-position: center;
                -moz-background-size: 32px;
                -ms-background-size: 32px;
                -webkit-background-size: 32px;
                background-size: 32px;
                vertical-align: -6px;
            }
            .arrival-time {
                padding-top: 25px;
            }
        }
        .urgent-icon {
            margin: 56px auto 0;
            width: 630px;
            height: 62px;
            background-image: url("data:image/png;base64,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");
            background-repeat: no-repeat;
            background-position: center;
            -moz-background-size: 200px 62px;
            -ms-background-size: 200px 62px;
            -webkit-background-size: 200px 62px;
            background-size: 200px 62px;
        }

        .urgent-service {
            margin: 0 auto;
            width: 630px;
            height: 66px;
            line-height: 66px;
            background-color: #f6f6f6;
            font-size: 28px;
            color: #999;
            text-align: center;
        }
    }
}
</style>
